import { HelperResult, UserContact, UserContactCategories } from '@openclassrooms/sdk-web';

import { UseFindFilters } from '../../utils/services/getUseFind';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useFindUserContacts, useUpdate: useUpdateUserContacts } = getCRUDHooks({
  entityName: 'userContacts',

  find: ({
    userId,
    filters,
  }: {
    userId: number;
    filters?: UseFindFilters<{ category: UserContactCategories }>;
  }): HelperResult<UserContact[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).userContacts.find(filters),

  update: (
    body: Omit<UserContact, 'id'>,
    { userId, context }: { userId: number; context: string }
  ): HelperResult<UserContact> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .userContacts.update('', body, false)
      .setHeader('X-Request-Context', context)
      .execute(),
});

export { useFindUserContacts, useUpdateUserContacts };
